<template>
  <div class="ghostContainer" :style="styleObj"><slot></slot></div>
</template>

<script>
import { px2vw } from '@/components/templates/helper';
export default {
  props: {
    verticalDirection: {
      type: String,
      require: true
    },
    verticalDistance: {
      type: Number,
      require: 50
    },
    horizontalDirection: {
      type: String,
      require: true,
      validator: function(val) {
        return ['left', 'right'].indexOf(val) > -1;
      }
    },
    horizontalDistance: {
      type: Number,
      require: true
    }
  },
  computed: {
    styleObj() {
      const style = {};
      const verticalDirection = this.verticalDirection;
      const horizontalDirection = this.horizontalDirection;
      style[verticalDirection] = px2vw(this.verticalDistance);
      style[horizontalDirection] = px2vw(this.horizontalDistance);
      return style;
    }
  }
};
</script>

<style lang="less" scoped>
.ghostContainer {
  position: absolute;
}
</style>
